import { Counter, CounterProps } from "PFApp/components/counter";
import React from "react";

import css from "./counter_tile.module.scss";

type CounterTileProps = Pick<CounterProps, "title" | "code" | "counter" | "onClick">;

export const CounterTile = (props: CounterTileProps): JSX.Element => (
  <Counter
    {...props}
    selected={false}
    disableIfZero={false}
    classes={{ button: css.root, number: css.counter, title: css.title }}
  />
);
